module.exports = __webpack_public_path__ + "FixelDisplay-BoldItalic.4dc161a5b59fd054a6be.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fixelDisplay/FixelDisplay-BoldItalic.woff2
// module id = ./src/assets/webfonts/fixelDisplay/FixelDisplay-BoldItalic.woff2
// module chunks = styles